import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceBase } from '../../service-base/ServiceBase';
import { environment } from './../../../../environments/environment';

@Injectable()
export class BarraUploadService extends ServiceBase {
  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.url;
  }
  
  private setUrlEnviarComunicado(): void {
    this.url = `${this.baseUrlService}/import_arquivo/upload`;
  }

  public enviarArquivo(form: FormData): Promise<any> {
    this.setUrlEnviarComunicado();

    return this.postFormData([], form)
  }


}